import React from 'react';
import { Text, Icon, useIsMobile } from '@amzn/storm-ui';
import styled from 'styled-components';
import { angleInlineEnd } from '@amzn/storm-ui-icons';
import { useAccountContext } from './AccountContextProvider';
import {findFeatureLaunchInfo} from "src/components/utils";
import {WeblabedFeatures} from "src/components/Types";

const AccountListItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const AccountListItemIcon = styled(Icon)`
  margin-inline-start: auto;
`;

const AccountInfoContainer = styled.div`
  margin-inline-end: 10px;
  & > p {
    text-align: left;
    margin-bottom: 2px;
  }
`;

type AccountListItemProps = {
  label: string;
  entityId?: string | undefined;
  isMultiCountryAccountType?: boolean;
  accountHasNestedAccounts?: boolean;
};

export const AccountListItem: React.VFC<AccountListItemProps> =
  ({label, entityId,
     accountHasNestedAccounts = false,
     isMultiCountryAccountType = false}) => {
  const {hasNestedAccounts} = useAccountContext();
  const isMobile = useIsMobile();
  const shouldRenderAngleIcon = !isMobile && (accountHasNestedAccounts || !isMultiCountryAccountType);
  return (
    <AccountListItemContainer>
      <AccountInfoContainer>
        <Text textColor="base" fontSize={isMobile ? "base" : "small"}>{label}</Text>
        {/* Commenting out entityId for now as UX requested */}
        {/* <Text textColor="tertiary" fontSize="mini">{entityId}</Text> */}
      </AccountInfoContainer>
      {shouldRenderAngleIcon && <AccountListItemIcon type={angleInlineEnd} aria-hidden={true} />}
    </AccountListItemContainer>
  );
}
